

















































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import DeclineEventInvitation from '@front-app/modules/event/components/DeclineEventInvitation.vue';
import TermsCard from '@front-app/components/cards/TermsCard.vue';
import TrModal from '@front-app/components/modals/TrModal.vue';
import { BannerLocation } from '@front-app/services/ActionApi/UserActionRequestModel';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { FullEvent } from '@front-app/services/EventsApi/EventModel';
import { Size } from '@front-app/components/constants';
import { useEventBanner } from '@front-app/modules/event/hooks/useEventBanner';
import { useEventMembershipRole } from '@front-app/hooks/useMembershipRole';

export default defineComponent({
	components: {
		CtaButton,
		DeclineEventInvitation,
		TermsCard,
		TrModal,
	},
	props: {
		event: {
			type: Object as PropType<FullEvent>,
			required: true,
		},
		groupId: {
			type: String,
			default: '',
		},
		isOpen: Boolean,
		isJoining: Boolean,
	},
	setup(props) {
		// Banner
		const eventBannerData = computed(() => ({
			eventId: props.event.id,
			location: BannerLocation.EVENT_PAGE_WELCOME,
			disableTracking: false,
			groupId: props.groupId,
		}));
		const {
			banner,
			bannerWrapper,
		} = useEventBanner(eventBannerData);
		// END Banner

		// Join, Terms, Decline invite
		const canDeclineInvitation = computed(() => useEventMembershipRole(props.event.role).isInvitee);
		// END Join & Terms

		return {
			canDeclineInvitation,
			banner,
			bannerWrapper,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
